export const extractContentPreview = (markdown: string): string => {
  const match = markdown.match(/^#{1,6}\s+(.+)/);

  if (match?.[1]) {
    return match[1].trim();
  }

  const sentences = markdown.match(/^(?:[^.!?]+[.!?]\s*){1,2}/);
  return sentences?.[0]?.trim() ?? '';
};
